'use strict';

import { CONST } from 'app_vodafone_ziggo/util/util';
import { handleTransition } from 'Util/transitions.js';

export default class VZConfiguratorLogin extends HTMLElement {
    constructor() {
        super();
        this.boundHandleRadioChange = this.handleRadioChange.bind(this);
    }

    connectedCallback() {
        this.setupRadioButtons();
        this.infoCard = this.querySelector('.js-configurator-login-info');

        // Set initial state based on checked radio
        const checkedRadio = this.querySelector('.js-question-content-toggle:checked');
        if (checkedRadio && checkedRadio.value === 'yes') {
            this.infoCard?.classList.remove(CONST.classes.dNone);
        }
    }

    disconnectedCallback() {
        const radioButtons = this.querySelectorAll('.js-question-content-toggle');
        radioButtons.forEach((radio) => {
            radio.removeEventListener('change', this.boundHandleRadioChange);
        });
    }

    setupRadioButtons() {
        const radioButtons = this.querySelectorAll('.js-question-content-toggle');
        radioButtons.forEach((radio) => {
            radio.addEventListener('change', this.boundHandleRadioChange);
        });
    }

    handleRadioChange(event) {
        const value = event.target.value;

        // Show/hide info card based on selection
        if (this.infoCard) {
            handleTransition(() => {
                if (value === 'yes') {
                    this.infoCard.classList.remove(CONST.classes.dNone);
                } else {
                    this.infoCard.classList.add(CONST.classes.dNone);
                }
            });
        }
    }
}

if (!window.customElements.get('vz-configurator-login')) {
    window.customElements.define('vz-configurator-login', VZConfiguratorLogin);
}
